/*
  PlentyBuy - global quick add.  [FIX C1]

  WHAT WAS BROKEN
  ---------------
  The click handler for [data-pb-add] used to live inside
  sections/pb-product-grid.liquid and was scoped to that one section:
      var root = document.getElementById('pbg-<section id>');
      root.addEventListener('click', ...)

  But snippets/card-product.liquid also renders pb-product-card, which means the
  same Add to cart button appears on:
      - collection pages      (main-collection-product-grid)
      - search results        (main-search)
      - related products      (related-products)
      - cart page upsell      (featured-collection)
  None of those surfaces registered a handler, so the button silently did
  nothing. Verified in the browser before this fix.

  WHAT THIS DOES
  --------------
  Binds ONCE at document level, so every surface that renders the card works.
  The fetch logic is unchanged from the original - same endpoint, same section
  rendering, same cart-drawer handoff. Only the binding scope changed, plus a
  real loading state and an inline error message on failure.

  TO REVERT
  ---------
  Delete this file, remove the <script> tag from layout/theme.liquid, and put the
  inline <script> back at the bottom of sections/pb-product-grid.liquid.
*/
(function () {
  if (window.pbQuickAddReady) return;
  window.pbQuickAddReady = true;

  var FAIL = 'Could not add that. Please try again.';

  function card(btn) {
    return btn.closest('.pbc') || btn.parentElement;
  }

  function clearError(btn) {
    var host = card(btn);
    var out = host && host.querySelector('[data-pb-add-error]');
    if (out) out.remove();
  }

  function showError(btn, msg) {
    clearError(btn);
    var out = document.createElement('p');
    out.className = 'pbc__adderr';
    out.setAttribute('data-pb-add-error', '');
    out.setAttribute('role', 'alert');
    out.textContent = msg;
    btn.insertAdjacentElement('afterend', out);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    var btn = e.target.closest('[data-pb-add]');
    if (!btn) return;

    e.preventDefault();

    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.dataset.loading === 'true') return;
    if (!window.routes || !window.routes.cart_add_url) return;

    clearError(btn);
    btn.dataset.loading = 'true';
    btn.setAttribute('aria-busy', 'true');

    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(id), quantity: 1 }] };

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message || FAIL);

        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(state);
        } else {
          window.location.href = window.routes.cart_url;
          return;
        }
        if (typeof window.pbSyncCart === 'function') window.pbSyncCart();
      })
      .catch(function (err) {
        showError(btn, (err && err.message) || FAIL);
      })
      .finally(function () {
        btn.dataset.loading = 'false';
        btn.removeAttribute('aria-busy');
      });
  });

  /* Hover image on product cards is attached on first pointer interaction
     rather than at render time, so a collection grid does not download two
     full images per card up front.  [FIX M5] */
  function attachHover(el) {
    var img = el.querySelector('[data-pb-hover-src]');
    if (!img) return;
    img.src = img.getAttribute('data-pb-hover-src');
    if (img.getAttribute('data-pb-hover-srcset')) {
      img.srcset = img.getAttribute('data-pb-hover-srcset');
    }
    img.removeAttribute('data-pb-hover-src');
  }

  document.addEventListener('pointerenter', function (e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    var c = e.target.closest('.pbc');
    if (c) attachHover(c);
  }, true);
})();
